import React from "react";
import leo from "../assets/leo.jpeg";

export default function hero() {
  return (
    <>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 lg:gap-12 py-8 px-4 md:px-32 mt-4">
        <div className="flex justify-center">
          <img src={leo} className="" alt="img" />
        </div>
        <div className="flex flex-col items-center justify-center mt-8 md:mt-0">
          <h1 className="text-4xl md:text-6xl font-bold text-center md:text-left text-[#1D4C60]">
            Leo Club, University of Delhi
          </h1>
          <p className="mt-4 text-center md:text-left text-gray-800">
            <strong>LEO Club – University of Delhi</strong> is the vibrant youth
            wing of <strong>Lions Club International</strong>, one of the
            world’s largest and most active non-profit organizations, with a
            presence in over 209 countries. We are driven by the core belief
            that leadership is best learned through service.
            <br />
            <br />
            At LEO Club DU, we provide young individuals a platform to develop
            and showcase their <strong>leadership skills</strong> by actively
            involving them in a wide range of{" "}
            <strong>social service activities</strong>. Our name stands for
            <strong>Leadership, Experience, and Opportunity</strong>– values
            that we strive to instill in every member. We believe that true
            leadership is born from experience and service. That’s why we create
            opportunities for young individuals to step up, take charge, and
            create real-world impact.
          </p>
        </div>
      </div>
    </>
  );
}
